import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AlchemyLogo } from "../../../../icons/alchemy.js";
import { ls } from "../../../../strings.js";
// eslint-disable-next-line jsdoc/require-jsdoc
export const ProtectedBy = () => (_jsxs("div", { className: "flex flex-row gap-1 items-center h-[14px] text-fg-disabled", children: [_jsx("span", { className: "text-[11px] pt-[1px]", children: ls.protectedBy.title }), _jsx(AlchemyLogo, {})] }));
//# sourceMappingURL=protected-by.js.map